import { createFileRoute, redirect, useRouterState } from "@tanstack/react-router";

import { getAccessToken } from "../auth";
import { PartnerDashboardApp, type DashboardScopeSearch, type View } from "../dashboard-app";
import { validateDashboardSearch } from "../dashboard-search";
import { requireInternalSession } from "../route-authorization";

const pathViews = {
  "/app/overview": "kpis",
  "/app/kpis": "kpis",
  "/app/opportunities": "opportunities",
  "/app/adjustments": "adjustments",
  "/app/account-mapping": "mappings",
  "/app/company-setup": "setup",
  "/app/audit-history": "audit",
  "/app/connections": "connections",
  "/app/people-access": "access",
  "/app/source-reconciliation": "reconciliation",
} as const satisfies Record<string, View>;
type DashboardPath = keyof typeof pathViews;

function AuthenticatedDashboard() {
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  const routePath = pathname as DashboardPath;
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <PartnerDashboardApp
      initialView={pathViews[routePath] ?? "kpis"}
      scope={search}
      onScopeChange={(change) => {
        void navigate({
          to: routePath,
          search: (current) => ({ ...current, ...change }),
          replace: true,
        });
      }}
    />
  );
}

export const Route = createFileRoute("/app")({
  validateSearch: (input: Record<string, unknown>): DashboardScopeSearch => validateDashboardSearch(input),
  beforeLoad: () => {
    if (!getAccessToken()) throw redirect({ to: "/login", search: { activated: false } });
    return requireInternalSession();
  },
  component: AuthenticatedDashboard,
});
